import React, { useEffect } from "react";


// hook pro zachyceni click eventu mimo komponentu
export function useHandleClickOutside(observedComponentRef: React.MutableRefObject<any>, onClickedOutside: (e: MouseEvent) => any) {
    useEffect(() => {
        function handleClick(event: MouseEvent) {
            if (observedComponentRef.current && observedComponentRef.current.contains && !observedComponentRef.current.contains(event.target))
                onClickedOutside(event)
        }

        document.addEventListener("click", handleClick)

        return () => document.removeEventListener("click", handleClick)

    }, [observedComponentRef, onClickedOutside]);
}